var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTopPicks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6 14.563h7.562a1 1 0 0 0 1-1V6c0-2.206-1.794-4-4-4H6C3.794 2 2 3.794 2 6v4.563c0 2.205 1.794 4 4 4zM26 2h-4.563c-2.205 0-4 1.794-4 4v7.563a1 1 0 0 0 1 1H26c2.206 0 4-1.795 4-4V6c0-2.206-1.794-4-4-4zM6 30h4.562c2.206 0 4-1.794 4-4v-7.563a1 1 0 0 0-1-1H6c-2.206 0-4 1.795-4 4V26c0 2.206 1.794 4 4 4zM26 17.438h-7.563a1 1 0 0 0-1 1V26c0 2.206 1.795 4 4 4H26c2.206 0 4-1.794 4-4v-4.563c0-2.205-1.794-4-4-4z",
    fill: "#4466ef",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopPicks);
export default __webpack_public_path__ + "static/media/TopPicks.c46aa74fa1bb99c48e7c09445d68149a.svg";
export { ForwardRef as ReactComponent };